import { GESTION_OPERATIVA_SET_ADD_BON_EDITABLE } from './constants'

export function setAdditionalBonEditable(bool) {

    return (dispatch) =>{
      dispatch({
      type: GESTION_OPERATIVA_SET_ADD_BON_EDITABLE,
      data: { isAdditionalBonEditable: bool }
      })
  };
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_ADD_BON_EDITABLE) {
      return {
        ...state,
        isAdditionalBonEditable: action.data.isAdditionalBonEditable
        }
  }
  else {
    return state
    }
}
